export const SN_UTIL = 'util'
export const UTIL_SERVICE_STATUS_DESC_UPDATED = SN_UTIL + '/SERVICE_STATUS_DESC_UPDATED'
export const UTIL_STORE_INV_CONFIG_UPDATED = SN_UTIL + '/STORE_INV_CONFIG_UPDATED'